import { action, makeObservable, observable } from "mobx";

class FilterSelectStore<T> {
  selectedOption: T;

  constructor(selectedOption: T) {
    makeObservable(this, {
      selectedOption: observable,
      setSelectedOption: action,
    });

    this.selectedOption = selectedOption;
  }

  setSelectedOption(selectedOption: T): void {
    this.selectedOption = selectedOption;
  }
}

export default FilterSelectStore;
